import type { TypeComponentCtaButtonEntry } from '@contentful-types/component-cta-button'
import { isOfType } from '@contentful-types/content-types'
import type { TypeVariationContainerAuthAndDeviceTypeCtaEntry } from '@contentful-types/variation-container-auth-and-device-type-cta'

import { ComponentContentTypes } from '@constants/enums/content-types'

import { useUserService, useBrowserService } from './services'

export type ctaArgType =
  | TypeComponentCtaButtonEntry
  | TypeVariationContainerAuthAndDeviceTypeCtaEntry

export const useGetAuthAndDeviceTypeCta = () => {
  const { isAnonymous } = useUserService().currentUser
  const { isMobile } = useBrowserService()

  /**
   * @param { TypeComponentCtaButton | TypeVariationContainerAuthAndDeviceTypeCta} entry
   * Check for auth and device type cta variation container or cta.
   * If cta, return the cta
   * Else, check for user's authentication state and device type to return override. Default CTA is returned if there is no override.
   * @return {TypeComponentCtaButton}
   */
  const getAuthAndDeviceTypeCta = (entry: ctaArgType): TypeComponentCtaButtonEntry => {
    if (isOfType(ComponentContentTypes.ComponentCtaButton)(entry)) {
      return entry as TypeComponentCtaButtonEntry
    }

    const {
      overrideForDesktopAnonymous,
      overrideForDesktopSignedIn,
      overrideForMobileAnonymous,
      overrideForMobileSignedIn,
      default: defaultCta,
    } = entry.fields

    if (overrideForDesktopAnonymous && isAnonymous && !isMobile) {
      return overrideForDesktopAnonymous
    }

    if (overrideForDesktopSignedIn && !isAnonymous && !isMobile) {
      return overrideForDesktopSignedIn
    }

    if (overrideForMobileAnonymous && isAnonymous && isMobile) {
      return overrideForMobileAnonymous
    }

    if (overrideForMobileSignedIn && !isAnonymous && isMobile) {
      return overrideForMobileSignedIn
    }

    return defaultCta as TypeComponentCtaButtonEntry
  }

  return { getAuthAndDeviceTypeCta }
}
